<template>
    <div class="d-flex" style="width: 100%; max-width: 170px">


        <button :class="`btn ${row.status_id.status.status_color} btn-sm btn-block`"  v-show="!show" block :id="`popover-status-${row.id}`" tabindex="0"
            @click.prevent="row.processo_automatizado == 0 ? show = true : ''">
            <strong class="text-uppercase" v-html="row.status_id.status.status_name || row.status_id.processo_status"></strong>
        </button><span v-if="!show" v-html="row.status_id.situacao"></span>
        <e-select route="processo/status" v-if="show" @input="setStatus"></e-select>
        <b-button v-if="show" variant="outline-secondary" size="sm" @click.prevent="show = false"><i class="far fa-times-circle"></i></b-button>

        <b-popover delay="100" v-if="row.status_id.title || row.status_id.tramitacao" :target="`popover-status-${row.id}`" placement="left" triggers="hover">
            <template #title v-if="row.status_id.title"><span v-html="row.status_id.title"></span></template>
            <span v-html="row.status_id.tramitacao"></span>
            {{ (!row.status && !row.status_id.title && row.processo_automatizado == 0) ?
                    'Clique para selecionar o status.' : ''
            }}
        </b-popover>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
    props: {
        row: Object,
    },
    data() {
        return {
            show: false,

        }
    },
    watch: {
        show(newVal) {
            if (newVal)
                this.$root.$emit('bv::hide::popover', `popover-status-${this.row.id}`);
        }
    },
    methods: {
        ...mapMutations('datatable', ['setReload']),
        async setStatus(value) {


            await this.$api.put(`processo/setStatus/${this.row.id}`, {
                status_id: value
            });


            this.setReload();
            this.show = false;
            this.$root.$emit('bv::hide::popover', `popover-status-${this.row.id}`);

        }

    }
}
</script>